// extracted by mini-css-extract-plugin
export default {"wrapper":"W4-z","play":"X4-z"};